import BlogCards from '../components/BlogCards';
import MainLayout from '../components/MainLayout';


export default function Blogs() {
  return (
    <>
      <MainLayout>
       
        <BlogCards/>

    </MainLayout>

    </>
  )
}
